import { TabControlAPI, TabWithContentAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import { Value } from '@philips-emr/tws-core';
import { HistoryService, HttpService, MessageService } from '@philips-emr/tws-core/lib/services';

import { ToastService } from '..';
import { Endpoint } from '../constants';
import providerContext from '../context/provider-context';

export class ShouldRenderTabsService {

  public static shouldRenderTab(api: TabWithContentAPI, shouldRenderTab: string): void {
    const { nrSeqTypeAccreditation } = HistoryService.getCurrentRouteParams();
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    HttpService.get<Record<string, Value>>(Endpoint.GET.TYPE_ACCREDITATION, { nrSeqProvider, nrSeqTypeAccreditation })
      .then(({ body }) => {
        if (body) {
          const shouldRender = body[shouldRenderTab];
          if (shouldRender === 'S') {
            api.setVisible(true);
          }
        }
      }).catch(() => api.setVisible(false));
  }

  public static chooseDefaultTab(tabControlAPI: TabControlAPI, tabs: string[]): void {
    const { nrSeqTypeAccreditation } = HistoryService.getCurrentRouteParams();
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    let found = false;
    tabs.forEach(tab => {
      if (!found) {
        HttpService.get<Record<string, Value>>(Endpoint.GET.TYPE_ACCREDITATION, { nrSeqProvider, nrSeqTypeAccreditation })
          .then(({ body }) => {
            if (body) {
              const shouldRender = body[tab];
              if (shouldRender === 'S' && !found) {
                found = true;
                tabControlAPI.setDefaultTab(tab);
                tabControlAPI.setActiveTab(tab);
              }
            }

          }).catch(() => ToastService.open({ message: MessageService.translate('provider.error-process-request'), level: ToastLevel.ERROR  }));
      }
    });
  }

}
